import { ref, reactive } from "vue";

const width = ref(window.innerWidth);
const height = ref(window.innerHeight);

function onResize() {
    width.value = window.innerWidth;
    height.value = window.innerHeight;
}

window.addEventListener("resize", onResize);

/**
 * Contains useful variables related to the whole app
 */
const appDimensions = reactive({
    width,
    height
});

export default appDimensions;
